// Keyword-targeted SEO layer: per-page metaTitle, outcome-led H1 and
// contextual CTA label. Kept separate from page content data so the
// commercial-search layer is reviewable in one place.
// Approved mapping: /app/memory/SEO_AUDIT.md (2026-10-15).

export const SERVICE_SEO = {
  // ---- Priority 8 (approved keyword titles/H1s/CTAs) ----
  "sales-transformation": {
    metaTitle: "Sales Transformation Consultants India | BLEZZINGS",
    heroH1: "Sales Transformation Consulting for Profitable Growth",
    heroCta: "Discuss Your Sales Challenge",
  },
  "go-to-market-market-entry": {
    metaTitle: "Go-to-Market Strategy Consultants India | BLEZZINGS",
    heroH1: "Go-to-Market Strategy That Turns Opportunity into Revenue",
    heroCta: "Discuss Your Market Entry Plans",
  },
  "channel-route-to-market": {
    metaTitle: "Distribution Strategy Consultants India | BLEZZINGS",
    heroH1: "Build a More Productive Distribution & Sales Network",
    heroCta: "Discuss Your Distribution Challenge",
  },
  "marketing-strategy-integrated-communications": {
    metaTitle: "Marketing Strategy Consultants India | BLEZZINGS",
    heroH1: "Marketing Strategy Built Around Business Growth",
    heroCta: "Discuss Your Marketing Challenge",
  },
  "performance-marketing-paid-media": {
    metaTitle: "Performance Marketing Agency Bengaluru | BLEZZINGS",
    heroH1: "Performance Marketing Focused on Profitable Customer Acquisition",
    heroCta: "Discuss Your Acquisition Goals",
  },
  "ecommerce-marketplace-growth": {
    metaTitle: "Multi-Marketplace & Quick Commerce Growth India | BLEZZINGS",
    heroH1: "Grow E-commerce Revenue Without Losing Sight of Profit",
    heroCta: "Discuss Your Marketplace Growth",
  },
  "brand-strategy-positioning": {
    metaTitle: "Brand Strategy & Positioning Consultants | BLEZZINGS",
    heroH1: "Build a Brand Customers Have a Reason to Choose",
    heroCta: "Discuss Your Brand Challenge",
  },

  // ---- Remaining services (lighter touch) ----
  "growth-strategy": {
    metaTitle: "Growth Strategy Consultants India | BLEZZINGS",
    heroH1: "A Clear Path to Your Next Phase of Growth",
    heroCta: "Discuss Your Growth Ambition",
  },
  "product-portfolio-strategy": {
    metaTitle: "Product Portfolio Strategy Consultants | BLEZZINGS",
    heroH1: "A Portfolio Built Around Where Profit Actually Comes From",
    heroCta: "Discuss Your Portfolio",
  },
  "pricing-revenue-management": {
    metaTitle: "Pricing Strategy Consultants India | BLEZZINGS",
    heroH1: "Pricing That Protects Margin and Drives Revenue",
    heroCta: "Discuss Your Pricing Challenge",
  },
  "commercial-excellence-operating-model": {
    metaTitle: "Commercial Excellence Consulting India | BLEZZINGS",
    heroH1: "A Commercial Organisation Built to Perform",
    heroCta: "Discuss Your Commercial Operations",
  },
  "market-opportunity-sizing": {
    metaTitle: "Market Opportunity Assessment Consultants | BLEZZINGS",
    heroH1: "Size the Opportunity Before You Commit",
    heroCta: "Discuss Your Market Opportunity",
  },
  "customer-buyer-insights": {
    metaTitle: "Customer Insights Consulting India | BLEZZINGS",
    heroH1: "Understand the Customer Behind the Decision",
    heroCta: "Discuss Your Research Needs",
  },
  "segmentation-targeting": {
    metaTitle: "Customer Segmentation Consulting India | BLEZZINGS",
    heroH1: "Segment Customers by Value, Not Just Labels",
    heroCta: "Discuss Your Segmentation Needs",
  },
  "competitive-intelligence": {
    metaTitle: "Competitive Intelligence Services India | BLEZZINGS",
    heroH1: "See Competitors' Moves Before They Cost You",
    heroCta: "Discuss Your Competitive Challenge",
  },
  "customer-decision-journey-intelligence": {
    metaTitle: "Customer Journey Research Consulting | BLEZZINGS",
    heroH1: "Know How Customers Actually Decide",
    heroCta: "Discuss Your Journey Research",
  },
  "trends-foresight-growth-opportunities": {
    metaTitle: "Market Trends & Foresight Consulting | BLEZZINGS",
    heroH1: "Spot the Next Opportunity Before the Market Does",
    heroCta: "Discuss Foresight for Growth",
  },
  "brand-architecture-portfolio": {
    metaTitle: "Brand Architecture Consulting India | BLEZZINGS",
    heroH1: "A Brand Architecture Customers Can Navigate",
    heroCta: "Discuss Your Brand Architecture",
  },
  "brand-identity-design-systems": {
    metaTitle: "Brand Identity & Design Systems | BLEZZINGS",
    heroH1: "An Identity That Makes the Brand Instantly Recognisable",
    heroCta: "Discuss Your Brand Identity",
  },
  "advertising-content-creative": {
    metaTitle: "Advertising & Creative Services India | BLEZZINGS",
    heroH1: "Creative Work Built to Sell, Not Just Impress",
    heroCta: "Discuss Your Creative Needs",
  },
  "public-relations-reputation": {
    metaTitle: "PR & Reputation Management Consulting | BLEZZINGS",
    heroH1: "A Reputation That Works as Hard as You Do",
    heroCta: "Discuss Your Reputation Goals",
  },
  "d2c-cro-digital-experience": {
    metaTitle: "D2C & Conversion Rate Optimisation Agency | BLEZZINGS",
    heroH1: "Turn More Visitors into Customers",
    heroCta: "Discuss Your Conversion Goals",
  },
  "crm-retention-loyalty": {
    metaTitle: "CRM & Retention Marketing Consulting | BLEZZINGS",
    heroH1: "Retention That Compounds Revenue",
    heroCta: "Discuss Your Retention Challenge",
  },
  "seo-content-ai-search": {
    metaTitle: "SEO & AI Search Optimisation Agency India | BLEZZINGS",
    heroH1: "Be Found Wherever Customers Search — Including AI",
    heroCta: "Discuss Your Search Visibility",
  },
  "social-influencer-creator-marketing": {
    metaTitle: "Influencer & Creator Marketing Agency India | BLEZZINGS",
    heroH1: "Creator Partnerships That Build Trust and Sales",
    heroCta: "Discuss Your Creator Strategy",
  },

  // ---- New landing pages (approved 2026-10-15) ----
  "amazon-marketplace-growth": {
    metaTitle: "Amazon Marketplace Management Agency India | BLEZZINGS",
    heroH1: "Grow on Amazon Without Losing the Margin",
    heroCta: "Discuss Your Amazon Growth Challenge",
  },
  "d2c-performance-marketing": {
    metaTitle: "D2C Performance Marketing Agency India | BLEZZINGS",
    heroH1: "Performance Marketing Built for D2C Economics",
    heroCta: "Review Your Customer Acquisition Strategy",
  },
};

export const INDUSTRY_SEO = {
  "fmcg-consumer-products": {
    metaTitle: "FMCG Growth & Distribution Consultants India | BLEZZINGS",
    heroCta: "Improve Your FMCG Distribution Performance",
  },
  "consumer-durables-electronics-appliances": {
    metaTitle: "Consumer Durables Growth Consulting | BLEZZINGS",
    heroCta: "Discuss Your Durables Growth",
  },
  "retail-d2c-ecommerce": {
    metaTitle: "Retail & D2C Growth Consulting | BLEZZINGS",
    heroCta: "Discuss Your Retail Growth",
  },
  "manufacturing-b2b": {
    metaTitle: "Manufacturing & B2B Growth Consulting | BLEZZINGS",
    heroCta: "Discuss Your B2B Growth",
  },
  "education-edtech": {
    metaTitle: "Education & EdTech Growth Consulting | BLEZZINGS",
    heroCta: "Discuss Your Education Growth",
  },
  "media-entertainment": {
    metaTitle: "Media & Entertainment Growth Consulting | BLEZZINGS",
    heroCta: "Discuss Your Media Growth",
  },
  "real-estate": {
    metaTitle: "Real Estate Marketing & Sales Consultants India | BLEZZINGS",
    heroCta: "Discuss Your Real Estate Growth",
  },
  "professional-services": {
    metaTitle: "Professional Services Marketing Consulting | BLEZZINGS",
    heroCta: "Discuss Your Firm's Growth",
  },
};

// Practice-hub override (approved: service #8 maps to the intelligence hub).
export const PRACTICE_SEO = {
  "market-customer-intelligence": {
    metaTitle: "Market Research Consultants India | BLEZZINGS",
    heroH1: "Market Intelligence for Better Commercial Decisions",
    heroCta: "Discuss Your Research Requirements",
  },
};
